<template>
  <div class="taobao_container">
    <md-field>
      <md-input-item
        ref="input0"
        v-model="taobaoAccount"
        placeholder="請輸入淘寶賬號"
      >
        <div class="viewbtn" slot="right" @click="bindTaoBaoAccount">
          <span>綁定</span>
        </div>
      </md-input-item>
    </md-field>
  </div>
</template>

<script>
import { InputItem, Field, Toast } from "mand-mobile";

export default {
  name: "coup",
  components: {
    [InputItem.name]: InputItem,
    [Field.name]: Field
  },
  data() {
    return {
    
    };
  },
  activated() {
    localStorage.clear();
   
  },
  methods: {
   
    
  }
};
</script>



